module.exports = __webpack_public_path__ + "img/stock6.892197db.png";